export const issueTypeNodes = view => [
  view.state.schema.nodes.form_label.create({id: 'type'}, view.state.schema.text('Type')),
  view.state.schema.nodes.form_select.create({
    id: 'type',
    name: 'type',
    settings: {
      values: [
        {
          "name": "Spike",
          "value": "Spike",
          "icon": "lightbulb outline orange"
        },
        {
          "name": "Bug",
          "value": "Bug",
          "icon": "bug red"
        },
        {
          "name": "Task",
          "value": "Task",
          "icon": "tasks purple",
          "selected": true
        },
        {
          "name": "Story",
          "value": "Story",
          "icon": "bookmark outline green"
        },
        {
          "name": "Epic",
          "value": "Epic",
          "icon": "wave square violet"
        }
      ]
    },
  })
];